import { get as apiGet, mock, isRealApiEnabled } from "./client";
import ibosMock, { iboUsers } from "./mocks/ibos";

/**
 * @endpoint GET /api/v1/ibos/search?q=&limit=
 *
 * Resolves to `{ items, total }`. `total` counts every matching account, which
 * can be far more than one page: QA searched "Jason" and never reached JASON
 * YOUNGBLOOD because the list stopped at 20 with nothing saying there was more.
 * Callers render the count and can re-request with a larger `limit`.
 *
 * @returns {Promise<{items: Ibo[], total: number}>}
 */
export function search(rawQuery, limit) {
  // The search tips offer `contact:<name>` and `ibo:<number>`; the API takes the
  // bare term.
  const query = String(rawQuery || "").replace(/^\s*(contact|ibo):\s*/i, "");
  if (isRealApiEnabled()) {
    const params = { q: query };
    if (limit) params.limit = limit;
    return apiGet("/v1/ibos/search", { query: params });
  }
  const q = String(query || "").toLowerCase();
  const matches = ibosMock.filter(
    (i) =>
      i.name.toLowerCase().includes(q) ||
      i.iboNumber.includes(q) ||
      (i.email || "").toLowerCase().includes(q)
  );
  const cap = Number(limit) || 20;
  return mock({ items: matches.slice(0, cap), total: matches.length });
}

/**
 * @endpoint GET /api/v1/ibos/:id
 * @returns {Promise<Ibo>}
 */
export function get(id) {
  if (isRealApiEnabled()) {
    return apiGet(`/v1/ibos/${id}`);
  }
  return mock(ibosMock.find((i) => i.id === id) || ibosMock[0]);
}

/**
 * @endpoint GET /api/v1/ibos/:id/users
 * @returns {Promise<IboUser[]>}
 */
export function getUsers(id) {
  if (isRealApiEnabled()) {
    return apiGet(`/v1/ibos/${id}/users`);
  }
  return mock(iboUsers[id] || []);
}
